<template>
  <div v-loading.fullscreen.lock="fullscreenLoading">
    <div id="digram-exam">

      <ChatbotComponent ref="chatbotComponent" title="ヤギディ診断" backButtonText="はじめから<br>やり直す" backRoute="/yagidigram"
        :showInfoButton="false" :showReloadButton="false" :initialMessages="initialFormattedMessages"
        :greetingMessage="greetingMessage" :firstPrompt="firstQuestion" :useDefaultApi="false"
        :showInputContainer="false" :backgroundType="'image'" :backgroundImage="'/static/img/digram/chatback.png'"
        :userFontColor="'#014a5c'" :userFontBackgroundColor="'#fff'" :userFontBorderColor="'#014a5c'"
        :botFontColor="'#014a5c'" @message-sent="handleMessageSent" @greeting-displayed="handleGreetingDisplayed">
        <template slot="logo">
          <img src="/static/img/digram/collabo_logo.png" alt="ヤギッシュとディグラム診断"
            style="display: block; width: 200px; height: auto; margin: 0 auto;">
        </template>
      </ChatbotComponent>

      <div class="digram-exam-footer chat-wrapper">
        <p>
          ヤギディ診断は、自己理解や求職活動の参考情報としてご利用いただくことを目的としており、診断結果の正確性や完全性、有用性等を保証するものではありません。<br>あくまで一助としてご活用いただき、ご利用に際してはご自身の責任において適切にご判断・ご対応いただきますようお願いいたします。
        </p>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../assets/scss/variables.scss";
</style>

<style lang="scss" scoped>
.digram-exam-footer {
  padding: 20px 0;
  font-size: 10px;
  opacity: 0.6;
}

.chat-wrapper {
  width: 100%;
  max-width: 768px;
  margin: 0 auto 10px;
}
</style>

<script>
import ChatbotComponent from '../ai/ChatbotComponent.vue'

export default {
  components: {
    ChatbotComponent
  },
  data () {
    return {
      fullscreenLoading: false,
      apiParams: {},
      initialFormattedMessages: [],
      greetingMessage: '早速はじめるメェ\n自分の直感を信じるッシュ!',
      firstQuestion: '',
      actionPosition: 'inside',
      actions: [
        {
          label: 'はい',
          value: 'はい'
        },
        {
          label: 'どちらでもない',
          value: 'どちらでもない'
        },
        {
          label: 'いいえ',
          value: 'いいえ'
        }
      ],
      questionList: [],
      answerList: [],
      maxQuestionCount: 20
    }
  },
  mounted () {
  },
  methods: {
    handleGreetingDisplayed () {
      this.$refs.chatbotComponent.isTyping = true
      // ChatbotComponentのisTypingをtrueにする
      const formData = new FormData()
      formData.append('answered_questions', this.questionList.join(','))

      this.$axios.post(this.$varuna.endPoints.getDigramQuestion, formData)
        .then(res => {
          // console.log(res)
          // ChatbotComponentのtypeMessageを呼び出す
          const restQuestionCount = '(残り' + (this.maxQuestionCount - (this.questionList.length + 1)) + '問)'
          this.$refs.chatbotComponent.showBotMessageFromParent(res.data.question_value, this.actions, this.questionList.length + 1, restQuestionCount, this.actionPosition)
          // this.firstQuestion = res.data.question_value
          this.questionList.push(res.data.question_key)
        })
    },
    handleMessageSent (message) {
      this.answerList.push(message.userMessage)
      if (this.answerList.length < this.maxQuestionCount) {
        this.handleGreetingDisplayed()
      } else {
        this.handleFinishMessage()
      }
    },
    handleFinishMessage () {
      // ランダムなuuidを生成 {yyyyMMddHHmmss}{random_string(26)}
      const formatDate = this.getYYYYMMDDHHMMSS()
      const randomString = this.randomBase(26)
      console.log(formatDate)
      console.log(randomString)
      const randomId = formatDate + randomString
      this.$cookies.set('digram_exam_id', randomId)
      const formData = new FormData()
      formData.append('answered_questions', this.questionList.join(','))
      formData.append('answers', this.answerList.join(','))
      formData.append('random_id', randomId)

      if (this.$firebase.isAuthenticated) {
        formData.append('uuid', this.$firebase.user.uid)
      }

      this.$axios.post(this.$varuna.endPoints.postDigramQuestionAnswer, formData)
        .then(res => {
          // this.$refs.chatbotComponent.showBotMessageFromParent(res.data.result, [
          //   {
          //     label: '診断結果を表示する',
          //     value: '診断結果を表示する',
          //     url: '/yagidigram/yagidigramresult?examresult=' + randomId
          //   }
          // ], null, null, this.actionPosition)
          this.$router.push('/yagidigram/yagidigramresult?examresult=' + randomId)
        })
    },
    randomBase (len = 26) {
      let s = ''
      // 文字列長が len に達するまでループ
      while (s.length < len) {
        // 乱数を26進文字列化し、先頭の "0." を削ったものを追加
        s += Math.random().toString(36).substring(2)
      }
      // len 文字だけ切り出して返す
      return s.substring(0, len)
    },
    getYYYYMMDDHHMMSS () {
      const d = new Date()
      const yyyy = d.getFullYear().toString()
      const MM = String(d.getMonth() + 1).padStart(2, '0') // 月は0始まりなので +1
      const dd = String(d.getDate()).padStart(2, '0')
      const HH = String(d.getHours()).padStart(2, '0')
      const mm = String(d.getMinutes()).padStart(2, '0')
      const ss = String(d.getSeconds()).padStart(2, '0')

      return `${yyyy}${MM}${dd}${HH}${mm}${ss}`
    }
  }
}
</script>
